import { requestServices } from "@/utils/request";
import { CounterStatus, ICounter } from "@/types/db/transaction";
import { valueEquals } from "element-plus";

/**
 *
 * Calls an endpoint to get the current receipt counter
 * we supply the reference and the groupID
 */
export async function getReceiptCounter(payload: {
  groupId: string;
  reference: string;
}): Promise<ICounter> {
  console.log(requestServices.getUri);
  const response = await requestServices({
    method: "GET",
    url: "/v1/counters",
    params: {
      groupId: payload.groupId,
      reference: payload.reference,
    },
    //   timeout: 100000, // 100 seconds cause adyen timesout in 90 secs
  });
  console.log("------------- response");
  console.log(response);

  return response.data.data;
}

/**
 *
 * Triggers backend to create the first receipt counter for a given reference and groupId
 * It is only triggered if a previous GET call returned 404 Not Found
 * @returns
 */
export async function postReceiptCounter(payload: {
  groupId: string;
  reference: string;
}): Promise<ICounter> {
  console.log("------ hi from postReceiptCounter");
  const response = await requestServices({
    method: "POST",
    url: "/v1/counters",
    data: {
      groupId: payload.groupId,
      reference: payload.reference,
    },
    //   timeout: 100000, // 100 seconds cause adyen timesout in 90 secs
  });
  console.log("------------- response");
  console.log(response);

  return response.data.data;
}

/**
 * Patch exact value to receipt counter
 */
export async function patchExactReceiptCounter(payload: {
  groupId: string;
  reference: string;
  value: number;
  status: CounterStatus;
}): Promise<ICounter> {
  console.log("------ hi from patchExactReceiptCounter");
  const response = await requestServices({
    method: "PATCH",
    url: "/v1/counters",
    data: {
      groupId: payload.groupId,
      reference: payload.reference,
      value: payload.value,
      status: payload.status,
    },
    //   timeout: 100000, // 100 seconds cause adyen timesout in 90 secs
  });
  console.log("------------- response");
  console.log(response);

  return response.data.data;
}

/**
 *
 * Increment receipt counter in backend
 *
 */
export async function patchToIncrementReceiptCounter(payload: {
  groupId: string;
  reference: string;
}): Promise<ICounter> {
  console.log("------ hi from postReceiptCounter");
  const response = await requestServices({
    method: "PATCH",
    url: "/v1/counters/increment",
    data: {
      groupId: payload.groupId,
      reference: payload.reference,
    },
    //   timeout: 100000, // 100 seconds cause adyen timesout in 90 secs
  });
  console.log("------------- response");
  console.log(response);

  return response.data.data;
}
